module.exports = __webpack_public_path__ + "static/img/5@2x.23393f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/5@2x.png
// module id = tzz9
// module chunks = 1